module.exports = __webpack_public_path__ + "static/media/ep_cover.03807042.jpg";